import { useContext } from "react";
import { BLEContext } from "../contexts/BleContext";

export const useBLE = () => {
  const context = useContext(BLEContext);
  if (!context) throw new Error("useBLE must be used within a BLEProvider");
  return context;
};
